import { render, staticRenderFns } from "./df-page-recipe.vue?vue&type=template&id=cb7f1df8"
import script from "./df-page-recipe.ts?vue&type=script&lang=js&external"
export * from "./df-page-recipe.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports